export const addPossessive = (word) => {
  if (word.endsWith("s")) {
    return word + "'"
  } else {
    return word + "'s"
  }
}
